/* eslint-disable no-nested-ternary */
import '../AccountingEntry.scss'
import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Chips } from 'primereact/chips'
import { confirmAction } from '../../../utils/helpers/common.js'
import useStatePrev from '../../../utils/hooks/useStatePrev.js'
import LabeledDropdown from '../../../components/common/form-components/labeled-dropdown/LabeledDropdown.jsx'
import Button from '../../../components/common/buttons/index.jsx'
import DataTableAccountSalaryConcepts from '../../../components/accounting-entry/DataTableAccountSalaryConcepts.jsx'
import SubstitutionsSelector from '../../../components/accounting-entry/SubstitutionsSelector.jsx'
import AccountingEntryService from '../../../services/accounting-entry/accountingEntry.service.js'
import LabeledCheckbox from '../../../components/common/form-components/labeled-checkbox/LabeledCheckbox.jsx'
import AccountSelector from '../../../components/accounting-entry/AccountSelector.jsx'

const AccountingEntrySalaryConceptForm = ({
  companyCode,
  currentRowData,
  hide,
}) => {
  const { formatMessage: msg } = useIntl()

  const selectorTransactionType = [
    { value: 'credit', label: msg({ id: 'credit' }) },
    { value: 'debit', label: msg({ id: 'debit' }) },
  ]

  // State
  const [loading, setLoading] = useState(false)
  const [concepts, setConcepts] = useState([])
  const [tempConcepts, setTempConcepts, prevTempConcepts] = useStatePrev([])
  const [substitutions, setSubstitutions] = useState('include')
  const [navarra, setNavarra] = useState('include')
  const [transactionType, setTransactionType] = useState('credit')
  const [types, setTypes] = useState(currentRowData?.types || [])

  const [id, setId] = useState(null)
  const [accountCode, setAccountCode] = useState(null)
  const [accountName, setAccountName] = useState(null)
  const [conceptCode, setConceptCode] = useState(null)
  const [isAdd, setIsAdd] = useState(true)

  useEffect(() => {
    if (currentRowData) {
      preprocessRowData(currentRowData)
    }
    retrieveConcepts(companyCode)
  }, [])

  const preprocessRowData = (rowData) => {
    if (rowData) {
      // Parse rowData to custom tempConcepts
      if (rowData.concepts) {
        setTempConcepts(
          rowData.concepts.map((tempConcept) => ({
            ...tempConcept,
            accountCode: rowData.accountCode,
          })),
        )
      }
      setId(rowData?.parentId)
      setAccountCode(rowData?.accountCode)
      setTransactionType(rowData?.transactionType)
      setSubstitutions(rowData?.agrupation?.substitutions)
      setNavarra(rowData?.agrupation?.navarra)
    }
  }

  const handleSubmit = async () => {
    const body = {
      agrupation: {
        substitutions,
        navarra,
      },
      companyCode: String(companyCode),
      accountCode,
      accountName,
      types: types?.map((type) => Number(type)),
      concepts: tempConcepts,
      transactionType,
      isAnalitic: true,
    }
    const response = currentRowData
      ? await AccountingEntryService.templates.updateTemplate(id, body)
      : await AccountingEntryService.templates.addTemplate(body)
    hide()
  }

  const retrieveConcepts = async (paramCompanyCode, customFilter) => {
    if (paramCompanyCode && paramCompanyCode !== undefined) {
      // Warning: consulta concepts en modo limit!==0 se comporta caóticamente
      const response = await AccountingEntryService.concepts.getConcepts({
        companyCode: paramCompanyCode,
        limit: 0,
      })
      // TODO: Filter existing concepts (previously added to tempConcepts)
      if (response.resp) {
        response.resp = response.resp.filter(
          (concept) =>
            !tempConcepts.some(
              (tempConcept) => tempConcept.conceptCode !== concept.conceptCode,
            ),
        )
        setConcepts(response.resp)
      }
    }
  }

  const filteredConcepts = () =>
    concepts.filter(
      (concept) =>
        !tempConcepts.some(
          (tempConcept) => tempConcept.conceptCode === concept.conceptCode,
        ),
    ) || []

  const handleRemoveAccount = async () => {
    const res = await confirmAction({
      action: () => AccountingEntryService.templates.deleteTemplate(id),
      areYouSureMsg: msg({ id: 'removeAccountWarning' }),
      yesMsg: msg({ id: 'button.delete' }),
      noMsg: msg({ id: 'button.cancel' }),
    })
    if (res) {
      hide()
    }
  }

  const handleRelateConcept = () => {
    const newRow = {
      accountCode,
      conceptCode,
      // Patched conceptName
      conceptName: concepts.filter(
        (concept) => concept.conceptCode === conceptCode,
      )[0].conceptName,
      isAdd,
    }

    // Update existing agreementCode
    setTempConcepts([...tempConcepts, newRow])
    setConceptCode(null)
  }

  const handleDeleteConcept = (rowData) => {
    setTempConcepts(
      tempConcepts.filter((concept) => concept._id !== rowData._id),
    )
  }

  const handleAccountChange = (rowData) => {
    if (rowData && rowData?.accountCode) {
      setAccountCode(rowData.accountCode)
      setAccountName(rowData.accountName)
    }
  }

  const formFields = (
    <>
      <div className="wrapper-flex-nowrap">
        <SubstitutionsSelector
          idLabel="substitutions"
          value={substitutions}
          onChange={(e) => setSubstitutions(e.target.value)}
        />
        <SubstitutionsSelector
          idLabel="navarra"
          value={navarra}
          onChange={(e) => setNavarra(e.target.value)}
        />
      </div>
      <AccountSelector
        companyCode={companyCode}
        value={accountCode}
        disabled={accountCode && (currentRowData || tempConcepts.length > 0)}
        onInit={handleAccountChange}
        onChange={handleAccountChange}
        currentRowData={currentRowData}
      />
      <LabeledDropdown
        idLabel="criterionDH"
        name="accountCode"
        required
        options={selectorTransactionType}
        optionLabel="label"
        optionValue="value"
        showClear={transactionType}
        value={transactionType}
        onChange={(e) => setTransactionType(e.target.value)}
      />
      <LabeledDropdown
        idLabel="salaryConcept"
        name="conceptCode"
        disabled={loading || !filteredConcepts().length > 0}
        required
        options={filteredConcepts()}
        optionLabel={(rowData) =>
          rowData.conceptCode + ' - ' + rowData.conceptName
        }
        optionValue="conceptCode"
        idPlaceHolder={loading ? 'loading' : null}
        showClear={conceptCode}
        value={conceptCode}
        filter
        onChange={(e) => setConceptCode(e.target.value)}
        onFilter={(e) => null}
      />
      <div style={{ display: 'inline-flex', width: '100%' }}>
        <LabeledCheckbox
          idLabel="addition"
          checked={isAdd}
          onChange={(e) => setIsAdd(e.target.value)}
        />
        <LabeledCheckbox
          idLabel="subtraction"
          checked={!isAdd}
          onChange={(e) => setIsAdd(!e.target.value)}
        />
      </div>
    </>
  )

  return (
    <div className="accounting-entry-form" style={{ minWidth: '860px' }}>
      <form className="form-content">
        <div
          className="wrapper-flex"
          style={{ display: 'inline-flex', width: '100%' }}
        >
          <div className="flex-grid" style={{ width: '40%' }}>
            {formFields}
          </div>
          <div className="flex-grid" style={{ width: '60%' }}>
            <div className="flex-container">
              <div className="control-label">
                {msg({ id: 'types' })} ({msg({ id: 'addWithIntro' })})
              </div>
              <div className="control-input">
                {/* <Chips value={types} onChange={(e) => setTypes(e.value)} placeholder='↓' /> */}
                <Chips value={types} onChange={(e) => setTypes(e.value)} />
              </div>
            </div>
            <DataTableAccountSalaryConcepts
              data={tempConcepts}
              showWhenNoData
              handleDelete={handleDeleteConcept}
            />
          </div>
        </div>
        <div className="wrapper-form-btns">
          <div className="flex-grid" style={{ width: '50%' }}>
            <Button
              type="button"
              btnClass="btn bg-danger"
              iconRight
              iconSize="1.2rem"
              iconClass="pi-trash"
              btnText={msg({ id: 'removeAccount' })}
              onHandleClick={handleRemoveAccount}
            />
          </div>
          <div className="flex-grid" style={{ width: '50%' }}>
            <Button
              type="button"
              isDisabled={
                loading ||
                !accountCode ||
                !substitutions ||
                !navarra ||
                !accountCode ||
                !conceptCode
              }
              btnClass="btn btn__bg-dark-blue"
              iconRight
              iconSize="1.2rem"
              iconClass="pi-plus"
              btnText="Añadir"
              onHandleClick={handleRelateConcept}
            />
            <Button
              btnClass="btn btn__bg-orange"
              iconClass="pi-save"
              iconRight
              btnText={msg({ id: 'button.save' })}
              // isDisabled={!tempConcepts.length>0}
              onHandleClick={(e) => handleSubmit(e)}
            />
          </div>
        </div>
      </form>
    </div>
  )
}
export default AccountingEntrySalaryConceptForm
